import { writable } from "svelte/store";
import * as api from "../apis/workMng.api";

const createInitialState = () => ({
    spt_se: "2",
    workMngList: [],
    currentList: [],
    keyword: "",
});

export const store = writable(createInitialState());

export function resetWorkMngStore() {
    store.set(createInitialState());
}

export async function apiGetWorkMng(spt_se, keyword) {
    try {
        const response = await api.apiGetWorkMng(spt_se, keyword);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiGetWorkMngDetail(rcvord_no) {
    try {
        const response = await api.apiGetWorkMngDetail(rcvord_no);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiPutWorkMng(rcvord_no, dvyfg_de, memo) {
    try {
        let formData = {
            rcvord_no: rcvord_no,
            dvyfg_de: dvyfg_de,
            memo: memo,
        };

        const response = await api.apiPutWorkMng(formData);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}
